<div class="stream-tab-container">
  <div class="mat-elevation-z8">
    <mat-table #table [dataSource]="dataSource" multiTemplateDataRows="true" class="table">
      <ng-container matColumnDef="streamName">
        <mat-header-cell *matHeaderCellDef class="header-label"> Name </mat-header-cell>
        <mat-cell *matCellDef="let element; let i = dataIndex" class="name-cell">
          <div class="first-row">
            <input
              matInput
              autocomplete="off"
              type="text"
              name="streamName"
              class="width-115"
              [(ngModel)]="element.streamName"
              [ngClass]="{ 'error-msg': checkValidation('name', element.streamName)?.isValid }"
              (ngModelChange)="
                checkValidation('name', element.streamName, element);
                onDataChange(element.streamName, i, configMapping.STREAM_NAME, element)
              "
              [matTooltip]="checkValidation('name', element.streamName)?.message"
            />
          </div>
          <div class="advanced-settings second-row">
            <a (click)="expandCollapse(element)"
              >Advanced settings
              <span> <i [ngClass]="element.isExpanded ? enabledIcon : disabledIcon"> </i></span
            ></a>
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="streamDscp">
        <mat-header-cell *matHeaderCellDef class="header-label"> DSCP </mat-header-cell>
        <mat-cell *matCellDef="let element; let i = dataIndex" class="dscp-cell">
          <div class="width-115 first-row">
            <mat-select
              class="option-list"
              #txInterfaceInput="ngModel"
              [(ngModel)]="element.streamDscp"
              [ngClass]="{
                'error-msg': checkValidation('dscp', element.streamDscp)?.isValid
              }"
              name="streamDscp"
              (selectionChange)="
                checkValidation('dscp', element.streamDscp, element);
                onDataChange(element.streamDscp, i, configMapping.TOS, element)
              "
              [matTooltip]="checkValidation('dscp', element.streamDscp)?.message"
            >
              <mat-option *ngFor="let dscp of dscpConfigTypes" [value]="dscp.id">
                {{ dscp.value }}
                ({{ dscp.id }})</mat-option
              >
            </mat-select>
          </div>
          <div class="vlan-fields second-row">
            <div class="width-60" *ngIf="vlanConfig === 'tagged' || vlanConfig === 'q_in_q'">
              <div class="label">S-VLAN Priority</div>
              <mat-select
                class="option-list width-60"
                #txInterfaceInput="ngModel"
                [(ngModel)]="element.stream_svlanPriority"
                name="streamDscp"
                [ngClass]="{
                  'error-msg': checkValidation('svlan', element.stream_svlanPriority, element)
                    ?.isValid
                }"
                (selectionChange)="
                  checkValidation('svlan', element.stream_svlanPriority, element);
                  onDataChange(
                    element.stream_svlanPriority,
                    i,
                    configMapping.SVLAN_PRIORITY,
                    element
                  )
                "
                [matTooltip]="
                  checkValidation('svlan', element.stream_svlanPriority, element)?.message
                "
              >
                <mat-option *ngFor="let svlan of svlanPriorityTypes" [value]="svlan.id">
                  {{ svlan.value }}</mat-option
                >
              </mat-select>
            </div>
            <div class="width-60 c-valn-priority" *ngIf="vlanConfig === 'q_in_q'">
              <div class="label">C-VLAN Priority</div>
              <mat-select
                class="option-list width-60"
                #txInterfaceInput="ngModel"
                [ngClass]="{
                  'error-msg': checkValidation('cvlan', element.stream_cvlanPriority, element)
                    ?.isValid
                }"
                [(ngModel)]="element.stream_cvlanPriority"
                name="streamDscp"
                (selectionChange)="
                  checkValidation('cvlan', element.stream_cvlanPriority, element);
                  onDataChange(
                    element.stream_cvlanPriority,
                    i,
                    configMapping.CVLAN_PRIORITY,
                    element
                  )
                "
                [matTooltip]="
                  checkValidation('cvlan', element.stream_cvlanPriority, element)?.message
                "
              >
                <mat-option *ngFor="let cvlan of cvlanPriorityTypes" [value]="cvlan.id">
                  {{ cvlan.value }}</mat-option
                >
              </mat-select>
            </div>
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="streamUlr">
        <mat-header-cell *matHeaderCellDef class="header-label">
          ULR
          <div class="sub-label">Mbps</div></mat-header-cell
        >
        <mat-cell *matCellDef="let element; let i = dataIndex">
          <div class="first-row">
            <input
              matInput
              autocomplete="off"
              type="number"
              (input)="enforceMaxLength($event, 8)"
              (blur)="onBlurDecimalCleanup(element, 'streamUlr')"
              name="streamUlr"
              class="width-50"
              [(ngModel)]="element.streamUlr"
              [ngClass]="{ 'error-msg': checkValidation('ulr', element.streamUlr)?.isValid }"
              (ngModelChange)="
                checkValidation('ulr', element.streamUlr, element);
                onDataChange(element.streamUlr, i, configMapping.ULR, element)
              "
              [matTooltip]="checkValidation('ulr', element.streamUlr)?.message"
            />
          </div>
          <div class="vlan-fields second-row" *ngIf="!layer3Test">
            <div class="width-60" *ngIf="vlanConfig === 'tagged' || vlanConfig === 'q_in_q'">
              <div class="label">S-VLAN Priority</div>
              <mat-select
                class="option-list width-60"
                #txInterfaceInput="ngModel"
                [(ngModel)]="element.stream_svlanPriority"
                name="streamDscp"
                [ngClass]="{
                  'error-msg': checkValidation('svlan', element.stream_svlanPriority, element)
                    ?.isValid
                }"
                (selectionChange)="
                  checkValidation('svlan', element.stream_svlanPriority, element);
                  onDataChange(
                    element.stream_svlanPriority,
                    i,
                    configMapping.SVLAN_PRIORITY,
                    element
                  )
                "
                [matTooltip]="
                  checkValidation('svlan', element.stream_svlanPriority, element)?.message
                "
              >
                <mat-option *ngFor="let svlan of svlanPriorityTypes" [value]="svlan.id">
                  {{ svlan.value }}</mat-option
                >
              </mat-select>
            </div>
            <div class="width-60 c-valn-priority" *ngIf="vlanConfig === 'q_in_q'">
              <div class="label">C-VLAN Priority</div>
              <mat-select
                class="option-list width-60"
                #txInterfaceInput="ngModel"
                [ngClass]="{
                  'error-msg': checkValidation('cvlan', element.stream_cvlanPriority, element)
                    ?.isValid
                }"
                [(ngModel)]="element.stream_cvlanPriority"
                name="streamDscp"
                (selectionChange)="
                  checkValidation('cvlan', element.stream_cvlanPriority, element);
                  onDataChange(
                    element.stream_cvlanPriority,
                    i,
                    configMapping.CVLAN_PRIORITY,
                    element
                  )
                "
                [matTooltip]="
                  checkValidation('cvlan', element.stream_cvlanPriority, element)?.message
                "
              >
                <mat-option *ngFor="let cvlan of cvlanPriorityTypes" [value]="cvlan.id">
                  {{ cvlan.value }}</mat-option
                >
              </mat-select>
            </div>
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="streamLoss">
        <mat-header-cell *matHeaderCellDef class="header-label">
          Frame Loss
          <div class="sub-label">(%)</div></mat-header-cell
        >
        <mat-cell *matCellDef="let element; let i = dataIndex">
          <div class="first-row">
            <input
              matInput
              autocomplete="off"
              type="number"
              (input)="enforceMaxLength($event, 7)"
              (blur)="onBlurDecimalCleanup(element, 'streamLoss')"
              name="streamLoss"
              class="width-40"
              [(ngModel)]="element.streamLoss"
              [ngClass]="{ 'error-msg': checkValidation('loss', element.streamLoss)?.isValid }"
              (ngModelChange)="
                checkValidation('loss', element.streamLoss, element);
                onDataChange(element.streamLoss, i, configMapping.LOSS, element)
              "
              [matTooltip]="checkValidation('loss', element.streamLoss)?.message"
            />
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="streamBerThreshold">
        <mat-header-cell *matHeaderCellDef class="header-label"> BER </mat-header-cell>
        <mat-cell *matCellDef="let element; let i = dataIndex">
          <div class="first-row">
            <mat-select
              class="option-list width-70"
              #streamBerThresholdInput="ngModel"
              [(ngModel)]="element.streamBerThreshold"
              name="streamBerThreshold"
              (selectionChange)="
                onDataChange(element.streamBerThreshold, i, configMapping.BER_THRESHOLD, element)
              "
            >
              <mat-option *ngFor="let type of berThresholdTypes" [value]="type.value">
                {{ type.name }}</mat-option
              >
            </mat-select>
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="streamFD">
        <mat-header-cell *matHeaderCellDef class="header-label">
          FD
          <div class="sub-label">(ms)</div></mat-header-cell
        >
        <mat-cell *matCellDef="let element; let i = dataIndex">
          <div class="first-row">
            <input
              matInput
              autocomplete="off"
              type="number"
              (input)="enforceMaxLength($event, 7)"
              (blur)="onBlurDecimalCleanup(element, 'streamFD')"
              name="streamFD"
              class="width-40"
              [(ngModel)]="element.streamFD"
              [ngClass]="{ 'error-msg': checkValidation('fd', element.streamFD)?.isValid }"
              (ngModelChange)="
                checkValidation('fd', element.streamFD, element);
                onDataChange(element.streamFD, i, configMapping.FD, element)
              "
              [matTooltip]="checkValidation('fd', element.streamFD)?.message"
            />
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="streamFDV">
        <mat-header-cell *matHeaderCellDef class="header-label">
          FDV
          <div class="sub-label">(ms)</div></mat-header-cell
        >
        <mat-cell *matCellDef="let element; let i = dataIndex">
          <div class="first-row">
            <input
              matInput
              autocomplete="off"
              type="number"
              (input)="enforceMaxLength($event, 7)"
              (blur)="onBlurDecimalCleanup(element, 'streamFDV')"
              name="streamFDV"
              class="width-40"
              [(ngModel)]="element.streamFDV"
              [ngClass]="{ 'error-msg': checkValidation('fdv', element.streamFDV)?.isValid }"
              (ngModelChange)="
                checkValidation('fdv', element.streamFDV, element);
                onDataChange(element.streamFDV, i, configMapping.FDV, element)
              "
              [matTooltip]="checkValidation('fdv', element.streamFDV)?.message"
            />
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="streamFrame">
        <mat-header-cell *matHeaderCellDef class="header-label">
          Frame
          <div class="sub-label">Size(s)</div></mat-header-cell
        >
        <mat-cell *matCellDef="let element; let i = dataIndex">
          <div class="frames width-120 first-row">
            <table>
              <ng-container *ngIf="isConfigTestEnable">
                <tr *ngIf="element.isMultiSelectEnable">
                  <th class="label">SCT:</th>
                  <td class="label-value">
                    <mat-label matTooltip="{{ element.streamSctFrame }}">{{
                      element.sctFrameDisplay
                    }}</mat-label>
                  </td>
                </tr>
              </ng-container>
              <ng-container *ngIf="isPerformanceTestEnable">
                <tr *ngIf="element.isMultiSelectEnable">
                  <th class="label">SPT:</th>
                  <td class="label-value">
                    <mat-label matTooltip="{{ element.streamSptFrame }}">{{
                      element.sptFrameDisplay
                    }}</mat-label>
                  </td>
                </tr>
              </ng-container>
              <tr *ngIf="!element.isMultiSelectEnable">
                <td class="label-value">
                  <mat-label matTooltip="{{ element.streamSptFrame }}">{{
                    element.sptFrameDisplay
                  }}</mat-label>
                </td>
              </tr>
            </table>
            <a class="edit" (click)="onClickFrameSize(element, i)">edit</a>
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="expandedDetail">
        <mat-cell *matCellDef="let element; let i = dataIndex">
          <div class="expand-fields">
            <div
              class="expand-fields-alignment"
              *ngIf="showFormField(configMapping.OVER_HEAD_BYTES)"
            >
              <div class="label">
                Overhead bytes
                <i
                  class="material-icons help-icon"
                  matTooltip="Adds a fixed number of bytes into the throughput calculations to derive a Network Throughput Rate."
                  >help_outline</i
                >
              </div>
              <input
                matInput
                autocomplete="off"
                type="number"
                name="streamOverheadBytes"
                class="width-50"
                [(ngModel)]="element.streamOverheadBytes"
                [ngClass]="{
                  'error-msg': checkValidation('overhead', element.streamOverheadBytes)?.isValid
                }"
                (ngModelChange)="
                  checkValidation('overhead', element.streamOverheadBytes, element);
                  onDataChange(
                    element.streamOverheadBytes,
                    i,
                    configMapping.OVER_HEAD_BYTES,
                    element
                  )
                "
                [matTooltip]="checkValidation('overhead', element.streamOverheadBytes)?.message"
              />
            </div>
            <div class="expand-fields-alignment" *ngIf="showFormField(configMapping.ERROR_ON_OOS)">
              <div class="label">
                Error on OOS
                <i
                  class="material-icons help-icon"
                  matTooltip="Out of sequence frames detected will cause the test to fail."
                  >help_outline</i
                >
              </div>
              <mat-select
                class="option-list width-70"
                #txInterfaceInput="ngModel"
                [(ngModel)]="element.streamOOS"
                name="streamOOS"
                (selectionChange)="
                  onDataChange(element.streamOOS, i, configMapping.ERROR_ON_OOS, element)
                "
              >
                <mat-option *ngFor="let oos of errorOnOssTypes" [value]="oos.value">
                  {{ oos.name }}</mat-option
                >
              </mat-select>
            </div>
          </div>
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="defaultColumns"></mat-header-row>
      <mat-row
        *matRowDef="let row; columns: defaultColumns"
        matRipple
        [ngClass]="'element-row'"
      ></mat-row>

      <mat-row
        *matRowDef="let row; columns: ['expandedDetail']"
        [ngClass]="row.isExpanded === true ? 'expand-row element-row' : 'element-row'"
        [@detailExpand]="row.isExpanded === true ? 'expanded' : 'collapsed'"
        style="overflow: hidden"
      >
      </mat-row>
    </mat-table>
  </div>
</div>
